import { useContext, useEffect } from 'react';

import { ctxNotification } from '@/contexts/NotificationCtx';
import { useTranslation } from 'react-i18next';

export default function VersionUpdate() {
  const { t } = useTranslation();
  const ctxNotify = useContext(ctxNotification);

  useEffect(() => {
    if (!ctxNotify) return;

    const lastKnownVersion = localStorage.getItem('lastKnownVersion');
    // If there is no lastKnownVersion, set it to the current version (VERSION)
    // and no message is shown
    if (lastKnownVersion === null) {
      localStorage.setItem('lastKnownVersion', VERSION);
      return;
    }

    // Only notify if the version is different from the stored version
    if (lastKnownVersion !== VERSION) {
      ctxNotify.showNotification('success', t('error.dialog.newVersionUpdate'), undefined, 10);
      localStorage.setItem('lastKnownVersion', VERSION);
    }
  }, [ctxNotify, t]);

  return null;
}
